import type { NavItem, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Ativa Comércio Exterior",
    title: "Ativa Comércio Exterior | Despachante Aduaneiro",
    description: "Despachante aduaneiro com mais de 30 anos de atuação em comércio exterior e logística internacional: desembaraço aduaneiro, assessoria em importação e exportação, logística internacional e consultoria especializada.",
    url: getOrigin(),
    locale: 'pt_BR',
    ogImage: 'https://rustic-spruce-hvt.cdn.modulify.website/images/ship-fog.jpg'
}

export type PhoneLine = {
    city: string
    label: string
    href: string
}

export const company = {
    legalName: "Ativa Comércio Exterior",
    tradeName: "Ativa Logística",
    cnpj: '40.411.720/0001-64',
    address: {
        street: "Rua Mayrink Veiga, 6",
        locality: "Centro, Rio de Janeiro, RJ",
        country: "Brasil"
    },
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Rua+Mayrink+Veiga%2C+6%2C+Centro%2C+Rio+de+Janeiro%2C+RJ%2C+Brasil',
    phones: [
        { city: "Rio de Janeiro", label: '(21) 3907-7507', href: 'tel:+552139077507' },
        { city: "Rio de Janeiro", label: '(21) 3907-7544', href: 'tel:+552139077544' },
        { city: "São Paulo", label: '(11) 4395-8870', href: 'tel:+551143958870' },
        { city: "Santos", label: '(13) 3500-7292', href: 'tel:+551335007292' }
    ] as Array<PhoneLine>,
    whatsappUrl: 'https://api.whatsapp.com/send/?phone=552139077544',
    clientAreaUrl: 'https://ativa.follownet.com.br/',
    simulationUrl: 'https://www.ativa.net/simula%C3%A7%C3%A3o',
    socials: {
        instagram: 'https://www.instagram.com/ativacomex/',
        linkedin: 'https://www.linkedin.com/company/ativacomex',
        facebook: 'https://www.facebook.com/ativalogisticaintl/'
    }
}

export const mainPhone: PhoneLine = company.phones[0]

// Phone lines grouped by city, in the order they are listed.
export const phonesByCity: Array<{ city: string, lines: Array<PhoneLine> }> = company.phones.reduce<Array<{ city: string, lines: Array<PhoneLine> }>>((groups, line) => {
    const group = groups.find((item) => item.city === line.city)

    if (group) group.lines.push(line)
    else groups.push({ city: line.city, lines: [line] })

    return groups
}, [])

export const clientAreaLabel = "Área reservada a clientes"

export const primaryNav: Array<NavItem> = [
    { label: "Home", href: '/' },
    { label: "Sobre", href: '/sobre' },
    { label: "Serviços", href: '/servicos' },
    { label: "Contato", href: '/contato' }
]

export const menuNav: Array<NavItem> = primaryNav
